import Flex from '@Components/Bases/Flex';
import { FormDatePicker, FormInput } from '@Components/Form';
import { disabledDatePickerTypingStyles } from '@Components/Form/styles';
import FormatNumberInput from '@Components/FormattedNumberInput/FormatNumberInput';
import { Box, InputLabel, Typography } from '@mui/material';

type BaseYearProps = {
  isCompletedTh: boolean;
  isCompletedEn: boolean;
};

const BaseYear = ({ isCompletedTh, isCompletedEn }: BaseYearProps) => {
  return (
    <>
      <Typography
        fontWeight={'bold'}
        mt={2}
        sx={{ textDecoration: 'underline' }}
      >
        ปีฐาน (ถ้ามี)
      </Typography>
      <Flex alignItems={'baseline'} gap={2} mt={1}>
        <InputLabel sx={{ textAlign: 'end', minWidth: '350px' }}>
          ปีฐาน
        </InputLabel>
        <FormDatePicker
          name="baseYear.year"
          sx={{ width: '100%', ...disabledDatePickerTypingStyles }}
          views={['year']}
          format="BBBB"
          placeholder="เลือกปีฐาน"
          slotProps={{
            field: {
              clearable: true,
              disabled: isCompletedTh || isCompletedEn,
            },
            toolbar: { hidden: false },
          }}
          localeText={{ toolbarTitle: 'เลือก ปี' }}
        />
      </Flex>
      <Flex alignItems={'baseline'} gap={2} mt={2}>
        <Box minWidth={'350px'}>
          <InputLabel sx={{ textAlign: 'end' }}>
            ปริมาณการปล่อยก๊าซเรือนกระจก ณ ปีฐาน
          </InputLabel>
          <Typography textAlign={'end'}>
            (ตันคาร์บอนไดออกไซด์เทียบเท่า, tCO<sub>2</sub>e)
          </Typography>
        </Box>
        <FormInput
          fullWidth
          name="baseYear.gasEmissionQuantity"
          placeholder="โปรดระบุจำนวน"
          sx={{
            '& input': {
              textAlign: 'right',
            },
          }}
          slotProps={{
            input: {
              disabled: isCompletedTh || isCompletedEn,
              inputComponent: FormatNumberInput as React.ComponentType,
              inputProps: {
                allowNegative: false,
              },
            },
          }}
        />
      </Flex>
    </>
  );
};
export default BaseYear;
